// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MP-H","content":"styles_content__1yyRV"};